export default __webpack_public_path__ + "static/media/landscape5.da470974.jpeg";